import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const callCustomerServiceDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "call-customer-service",
        action: "navigate",
        type: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default callCustomerServiceDataPush;
